module.exports = __webpack_public_path__ + "static/media/TT_logo-2.c8ddd751.svg";